import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X, ArrowUpCircle } from "lucide-react";
import api from "@/lib/api";
import { yellowBtn } from "@/lib/airep";
import { SavedMethod } from "@/components/PayPalCheckout";

const eur = (c) => (c / 100).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
const ORDER = ["free", "base", "pro", "enterprise"];

export function UpgradeModal({ onClose, onDone, reason }) {
  const [me, setMe] = useState(null);
  const [quotes, setQuotes] = useState({});
  const [sel, setSel] = useState(null);
  const [pm, setPm] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/airep/me").then(async ({ data }) => {
      setMe(data);
      setPm(data.airep.payment_method);
      const higher = ORDER.slice(ORDER.indexOf(data.airep.plan) + 1).filter((k) => data.plans[k]?.price_month_cents != null);
      const qs = {};
      for (const k of higher) { try { qs[k] = (await api.get(`/airep/upgrade/quote?plan=${k}`)).data; } catch { /* skip */ } }
      setQuotes(qs);
      setSel(higher[0] || null);
    });
  }, []);
  const go = async () => {
    setBusy(true);
    try { await api.post("/airep/upgrade", { plan: sel }); toast.success("Piano aggiornato"); onDone?.(); onClose(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Upgrade non riuscito"); }
    setBusy(false);
  };
  const q = sel && quotes[sel];
  const vat = me?.vat_rate ?? 22;
  return (
    <div className="fixed inset-0 z-[60] bg-black/50 backdrop-blur-sm grid place-items-center p-4" onClick={onClose}>
      <div className="bg-white text-slate-900 rounded-3xl w-full max-w-lg max-h-[90vh] overflow-y-auto p-6 space-y-4" onClick={(e) => e.stopPropagation()} data-testid="upgrade-modal">
        <div className="flex items-start justify-between gap-3">
          <div><h2 className="font-display text-2xl font-extrabold flex items-center gap-2"><ArrowUpCircle className="h-6 w-6" /> Passa a un piano superiore</h2>
            <p className="text-sm text-slate-600 mt-1">{reason || "Hai raggiunto i limiti del tuo piano."}</p></div>
          <button onClick={onClose} className="h-9 w-9 shrink-0 grid place-items-center rounded-full bg-[#E3FF00]" data-testid="upgrade-close"><X className="h-4 w-4" /></button>
        </div>
        {!me ? <p className="text-sm text-slate-500">Caricamento…</p> : !Object.keys(quotes).length ? (
          <a href="mailto:info@mypasspartu.it?subject=AI-Report%20Enterprise" className={`${yellowBtn} w-full py-3`} data-testid="upgrade-contact">Contattaci per Enterprise</a>
        ) : (
          <>
            <div className="space-y-2">
              {Object.entries(quotes).map(([k, qq]) => (
                <button key={k} onClick={() => setSel(k)} className={`w-full text-left rounded-2xl border-2 p-4 ${sel === k ? "border-slate-900 bg-[#E3FF00]/30" : "border-slate-200"}`} data-testid={`upgrade-plan-${k}`}>
                  <div className="flex justify-between font-semibold"><span>{me.plans[k].label}</span><span>{qq.trial ? "0 € (in prova)" : `${eur(qq.net_cents)} + IVA`}</span></div>
                  <div className="text-xs text-slate-600 mt-1">{me.plans[k].participants_month ? `${me.plans[k].participants_month} partecipanti/mese` : "partecipanti illimitati"}{me.plans[k].participants_event ? ` (max ${me.plans[k].participants_event} per evento)` : ""} · {me.plans[k].ai_reports_month ?? "∞"} report AI al mese{qq.remaining_days != null && !qq.trial ? ` · differenza per i ${qq.remaining_days} giorni rimanenti` : ""}</div>
                </button>
              ))}
            </div>
            {q && q.net_cents > 0 && <SavedMethod method={pm} onChange={setPm} />}
            {q && (q.net_cents === 0 || pm) && <button disabled={busy} onClick={go} className={`${yellowBtn} w-full py-3.5`} data-testid="upgrade-confirm">{q.net_cents > 0 ? `Paga ${eur(Math.round(q.net_cents * (1 + vat / 100)))} (IVA incl.) e passa a ${me.plans[sel].label}` : `Passa a ${me.plans[sel].label}`}</button>}
          </>
        )}
      </div>
    </div>
  );
}
